import { Box, Typography, Link } from '@mui/material'
import { COLORS } from '../constants/colors'
import { TEXT } from '../constants/text'

export default function InfoPage() {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 900, mb: 3, color: COLORS.gold.primary }}>
        About {TEXT.BUSINESS.NAME}
      </Typography>

      <Section title="What We Do">
        {TEXT.BUSINESS.NAME} is a non-custodial signal intelligence platform built for Solana.
        We monitor on-chain data in real-time — new token launches, wallet movements,
        liquidity events — and surface actionable signals so you can trade smarter.
      </Section>

      <Section title="Non-Custodial">
        We never touch your keys. Wallet connection is used solely for authentication and
        tier verification. All trading decisions remain yours. Always.
      </Section>

      <Section title="How It Works">
        Our engine ingests data from Solana programs (Raydium, Pump.fun, Meteora, and more)
        through protocol-agnostic adapters. Every new token is scored by our Rug-Score Algorithm
        in under 1.5 seconds — checking mint authority, freeze authority, LP burns, top holders,
        deployer history, and Jito bundle patterns.
      </Section>

      <Section title="Tiers">
        <strong>Free</strong> — Delayed feed (30s), basic rug checks.<br />
        <strong>Pro ($99/mo)</strong> — Real-time feed, full rug score, whale alerts, smart money tracking.<br />
        <strong>Elite ($299/mo)</strong> — Boss Man signals, bundle detection, Telegram alerts, API access.
      </Section>

      <Section title="Contact">
        <Link href={`https://${TEXT.BUSINESS.DOMAIN}`} target="_blank" rel="noopener" sx={{ color: COLORS.blue.primary }}>
          {TEXT.BUSINESS.DOMAIN}
        </Link>
      </Section>
    </Box>
  )
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography sx={{ fontWeight: 700, fontSize: '1rem', mb: 1, color: COLORS.text.primary }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: '0.85rem', color: COLORS.text.secondary, lineHeight: 1.8 }}>
        {children}
      </Typography>
    </Box>
  )
}
